export default {
  ["SET_SUPPLIER"](state, payload) {
    state.supplier = payload;
  },
  ["RESET_SUPPLIER"](state) {
    state.supplier = [];
  }
};
